import { events } from '../../events';
import { BaseComponent } from '../../framework/base.component';
import { component } from '../../framework/component.decorator';
import { OnInit } from '../../framework/on-init.interface';
import { button$ } from '../../framework/templating/button.element';
import { div$ } from '../../framework/templating/div.element';
import { icon$ } from '../../framework/templating/icon.element';
import { span$ } from '../../framework/templating/span.element';
import styles from './toaster.component.scss';

@component({
  selector: 'app-toaster',
  styles,
})
export class ToasterComponent
  extends BaseComponent<ToasterComponent>
  implements OnInit
{
  private container$ = div$('toast-container hide');

  async createInitialComponent(): Promise<HTMLElement | HTMLElement[]> {
    return [
      div$('toast-container', [
        div$('toast', [
          span$({ textContent: 'Test toast' }),
          button$('close', [icon$('x')]),
        ]),
      ]),
    ];
  }

  async onInit() {
    events.on('toast', ({ type, message, duration }) =>
      this.scheduleToast(type, message, duration)
    );
  }

  private scheduleToast(
    type: 'error' | 'warn' | 'info',
    message: string,
    duration: number
  ) {
    this.container$.classList.remove('hide');

    const toast$ = this.createToast(message);
  }

  private createToast(textContent: string) {
    const toast$ = div$('toast', [
      span$({ textContent }),
      button$(
        'close',
        {
          onCreate: (element) => this.removeToast(toast$),
        },
        [icon$('x')]
      ),
    ]);

    return toast$;
  }

  private removeToast(toast$: HTMLDivElement) {}
}
